<header>
  <nav class="navbar navbar-expand navbar-dark-pepsico fixed-top">
    <div class="container-fluid">
      <a class="navbar-brand" routerLink="home">
        <img src="./assets/images/logoCAE_bw.png" class="logoTxt">
      </a>

      <div class="collapse navbar-collapse" id="navbarCollapse">
        <button class="navbar-toggler mnu-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#circleMnu"
          aria-controls="circleMnu" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="circle-menu collapse" id="circleMnu">
          @for (item of principalMenuItems; track item.path) {
          @if(item.path.includes('my-orders')) {
          <a [routerLink]="item.path" class="circle" [ngClass]="item.class" *appShowFeature="Feature.MyOrders">
            <img [src]="'assets/images/mnu/' + item.image" class="iconMnu">
          </a>

          } @else {
          <a [routerLink]="item.path" class="circle" [ngClass]="item.class">
            <img [src]="'assets/images/mnu/' + item.image" class="iconMnu">
          </a>
          }
          }
        </div>

        <form class="d-flex ms-auto" role="search">
          <ul class="navbar-nav me-auto mb-0">
            <li class="nav-item dropdown show">
              <div class="hover-label-wrapper">
                <a class="nav-link white btn-hover-pepsico fnt-12" href="javascript:void(0)" role="button"
                  (click)="openModalMyProgress()">
                  <img src="./assets/images/graph.svg" width="25">
                </a>
                <div class="hover-label">Mi avance</div>
              </div>
            </li>
            <!-- PERFIL -->
            <li class="nav-item dropdown show">
              <div class="hover-label-wrapper">
                <a class="nav-link white btn-hover-pepsico fnt-12" routerLink="profile" role="button">
                  <img [src]="holidayDataService.holidaysData()[HolidayTypes.Profile]" width="25">
                </a>
                <div class="hover-label">Perfil</div>
              </div>
            </li>
            <!-- CARRITO -->
            <li class="nav-item dropdown show" *appShowFeature="Feature.Cart">
              <div class="hover-label-wrapper">
                <cart-nav />
              </div>
            </li>

            <li class="nav-item dropdown show">
              <div class="hover-label-wrapper">
                <notifications-nav />
              </div>
            </li>

            <!-- WISHLIST -->
            <li class="nav-item dropdown show" *appShowFeature="Feature.Whishlist">
              <div class="hover-label-wrapper">
                <wish-list-nav />
              </div>
            </li>
            <!-- SALIR -->
            <li class="nav-item">
              <div class="hover-label-wrapper">
                <a class="nav-link white btn-hover-pepsico fnt-12" href="javascript:void(0)" (click)="logOut()"
                  role="button">
                  <svg-icon svgName="bi-door-open-fill" [width]="20" [height]="20" />
                </a>
                <div class="hover-label">Salir</div>
              </div>
            </li>
          </ul>
        </form>
      </div>
    </div>
  </nav>

</header>